
import React, { useState } from "react";
import { Check, CreditCard, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SuccessViewProps {
  onClose: () => void;
  onSubscribeNow: () => void;
  isSubscribing: boolean;
  errorMessage: string | null;
  primaryColor: string;
}

export function SuccessView({ 
  onClose, 
  onSubscribeNow, 
  isSubscribing, 
  errorMessage,
  primaryColor 
}: SuccessViewProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-center">
      <div className="bg-green-100 rounded-full p-4 mb-4">
        <Check className="h-8 w-8 text-green-600" />
      </div>
      <h3 className="text-xl font-medium mb-2">Request Submitted!</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        Thank you for your interest in our Church Plan. Our team will contact you shortly with custom pricing and features information.
      </p>
      
      <div className="mt-4 mb-6 p-4 border border-primary/30 rounded-lg bg-primary/5 max-w-md">
        <h4 className="font-medium mb-2">Ready to get started now?</h4>
        <p className="text-sm mb-4">
          You can subscribe to our Church Plan immediately for $49.99/month and gain instant access to all features.
        </p>
        <Button
          onClick={onSubscribeNow}
          className="px-8 w-full flex items-center justify-center gap-2"
          style={{ backgroundColor: primaryColor }}
          disabled={isSubscribing}
        >
          {isSubscribing ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Processing...
            </>
          ) : (
            <>
              <CreditCard className="h-4 w-4" />
              Subscribe Now - $49.99/month
            </>
          )}
        </Button>
        {errorMessage && (
          <div className="mt-2 p-2 bg-red-50 border border-red-100 rounded text-red-600 text-sm">
            {errorMessage}
          </div>
        )}
        <p className="text-xs text-muted-foreground mt-2">
          Our team will still contact you to set up your church profile and provide personalized support.
        </p>
      </div>
      
      <Button
        onClick={onClose}
        className="px-8"
        variant="outline"
      >
        Close
      </Button>
    </div>
  );
}
